import { Action, Dispatch } from "redux";
import { FetchCustomerServiceInfo, actionTypes, apiStatuses } from "./Actions";

const fetchCustomerServiceInfo: FetchCustomerServiceInfo = () => (
  dispatch: Dispatch<Action>
) => {
  dispatch({
    status: apiStatuses.LOADING,
    type: actionTypes.FETCH_CUSTOMERSERVICE_INFO
  });

  fetch(`/bestilling/api/v2/business/clientinfo.json`)
    .then(res => res.json())
    .then(data => {
      dispatch({
        data,
        status: apiStatuses.SUCCESS,
        type: actionTypes.FETCH_CUSTOMERSERVICE_INFO
      });
    });
};

export default fetchCustomerServiceInfo;
